export default __webpack_public_path__ + "static/media/whatsappContact.149c09a9.png";